export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5054.3d0e508a.jpg";